import className from 'classnames';
import { Checkbox } from 'homecredit-ui';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { string } from 'prop-types';

import { additionDocument, generateUserToken } from 'actions/clz/0bod';
import Button from 'components/common/Button';
import Modal from 'components/common/Modal';
import Logo from 'components/Logo';
import { sendGACustom, sendGAEvent } from 'utils/ga';
import { configs, LIMIT_DOCUMENTS } from './constant';
import s from './style.css';
import { GA } from '../constant';
import icon1 from './images/benefit-interest.svg';
import icon2 from './images/check.svg';
import icon3 from './images/cash.svg';
import deleteIcon from './images/delete-icon.svg';
import arrowDown from '../../../../../public/images/icon/arrowDown.svg';

class AdditionalUserDocument extends React.PureComponent {
  state = {
    visibleModalConfirm: false,
    visibleModalSelectDoc: false,
    loading: false,
    // Document Name must be based on Docs Type of Customer-bod-service
    selectedDocument: {
      BANK_STATMENT_3: false,
      LAB_CONTRACT: false,
      PAY_SLIP_ANY: false,
      BILL_ANY: false,
      MEDICAL_INS_CARD: false,
      SOCIAL_INSURANCE: false,
    },
  };

  async componentDidMount() {
    const { token, user, onGenerateUserToken } = this.props;
    const { cuid, id } = user;
    sendGAEvent(
      'Visit_Page',
      'New_Customer_Select_Docs_Page',
      'ACL_0BOD_New_Customer_Select_Docs',
    );
    await onGenerateUserToken(cuid, id, token);
  }

  onChangeDocument = key => value => {
    const trackGADoc = GA.DOCUMENT[key];
    sendGAEvent(
      trackGADoc?.action,
      trackGADoc?.label,
      'ACL_0BOD_New_Customer_Select_Docs',
    );
    this.setState(prevState => ({
      selectedDocument: {
        ...prevState.selectedDocument,
        [key]: value,
      },
    }));
  };

  onCheckAdditional = () => {
    const { selectedDocument } = this.state;
    return (
      selectedDocument.MEDICAL_INS_CARD ||
      selectedDocument.SOCIAL_INSURANCE ||
      Object.values(selectedDocument).filter(value => value).length >=
        LIMIT_DOCUMENTS
    );
  };

  onHandleSubmit = async () => {
    const { selectedDocument } = this.state;
    const { onAdditionDocument, userToken } = this.props;
    const isChecked = this.onCheckAdditional();
    this.setState(prevState => ({ loading: !prevState.loading }));
    const payload = {
      additionalDocuments: [],
    };

    Object.entries(selectedDocument).forEach(([key, val]) => {
      if (val)
        payload.additionalDocuments.push({
          number: '0',
          type: key,
        });
    });

    if (isChecked) {
      const res = await onAdditionDocument(payload, userToken);
      res && this.setState(prevState => ({ loading: !prevState.loading }));
    }
    sendGAEvent(
      'Tap_Continue_Button',
      'Continue_Button',
      'ACL_0BOD_New_Customer_Select_Docs',
    );
    sendGACustom(3, 'additional_doc');
  };

  toogleConfirmModal = () => {
    const isChecked = this.onCheckAdditional();
    if (isChecked)
      this.setState(prevState => ({
        visibleModalConfirm: !prevState.visibleModalConfirm,
      }));
  };

  toogleSelectDocModal = () => {
    this.setState(prevState => ({
      visibleModalSelectDoc: !prevState.visibleModalSelectDoc,
    }));
  };

  renderDocumentOptions = (renderSelected = false) => {
    const { selectedDocument } = this.state;
    return (
      <div className={s.selectionContainer}>
        <div className={s.docsList}>
          {configs.map(item => {
            const isActive = selectedDocument[item.id];
            return (
              (!renderSelected || isActive) && (
                <div key={item.id} className={s.docsItem}>
                  <div className={s.docItemLeft}>
                    <img src={item.icon} alt={item.label} />
                    <div className={s.docItemText}>
                      <h5>{item.label}</h5>
                      <p>{item.note}</p>
                    </div>
                  </div>
                  {!renderSelected ? (
                    <Checkbox
                      name={item.id}
                      onChange={this.onChangeDocument(item.id)}
                      checked={isActive}
                      className={className(s.radio, isActive && s.active)}
                    />
                  ) : (
                    <a
                      href="javascript:void(0);"
                      onClick={() => this.onChangeDocument(item.id)(false)}
                    >
                      <img src={deleteIcon} alt="Delete document" />
                    </a>
                  )}
                </div>
              )
            );
          })}
        </div>
      </div>
    );
  };

  render() {
    const {
      selectedDocument,
      visibleModalConfirm,
      visibleModalSelectDoc,
      loading,
    } = this.state;
    const { fullName } = this.props;
    const countSelectDocument = Object.values(selectedDocument).filter(
      value => value,
    ).length;

    const isChecked = this.onCheckAdditional();

    const openAttention =
      selectedDocument.BILL_ANY &&
      countSelectDocument === LIMIT_DOCUMENTS &&
      !selectedDocument.MEDICAL_INS_CARD &&
      !selectedDocument.SOCIAL_INSURANCE;

    return (
      <div className="container">
        <div className={s.container}>
          <Logo />
          <p>Bổ sung giấy tờ bạn có</p>
          <div className={s.content}>
            <div className={s.point}>
              <p>Lợi ích khi cung cấp thêm giấy tờ:</p>
              <div className={s.wrapperNote}>
                <div className={s.boxNote}>
                  <img src={icon3} alt="iconCash" />
                  <p>
                    <strong>Số tiền vay </strong>cao hơn
                  </p>
                </div>
                <div className={s.boxNote}>
                  <img src={icon1} alt="iconStar" />
                  <p>
                    <strong>Lãi suất thấp </strong> hơn so với việc không cung
                    cấp chứng từ
                  </p>
                </div>
              </div>
            </div>
            <hr className={s.dashed} />
            <div className={s.pointNote}>
              <img src={icon2} alt="" />
              <p>
                Home Credit cam kết chỉ sử dụng thông tin của bạn cho mục đích
                thẩm định và phê duyệt hồ sơ vay
              </p>
            </div>

            {(openAttention || (!isChecked && countSelectDocument === 1)) && (
              <div className={className(s.noteContainer, s.noteBorder)}>
                <p className={s.noteTitle}>Lưu ý</p>
                <p className={s.noteContent}>
                  {openAttention ? (
                    <>
                      Hoá đơn điện, nước phải trùng tên khách hàng &quot;<strong
                      >
                        {fullName}
                      </strong>&quot;
                    </>
                  ) : (
                    <>
                      Bạn cần chọn nhiều hơn 1 loại giấy tờ. Bấm vào "Chọn giấy
                      tờ" bên dưới để thêm
                    </>
                  )}
                </p>
              </div>
            )}

            <div
              className={s.noteContainer}
              onClick={this.toogleSelectDocModal}
            >
              <p className={s.noteContent}>
                <strong>
                  CHỌN GIẤY TỜ{' '}
                  {countSelectDocument ? `(${countSelectDocument})` : ''}
                </strong>
              </p>
              <img src={arrowDown} alt="arrowDown" />
            </div>

            {this.renderDocumentOptions(true)}
          </div>
          <Button
            className={s.btnStart}
            disabled={!isChecked}
            onClick={this.toogleConfirmModal}
          >
            Hoàn Thành
          </Button>
        </div>
        <Modal
          className={s.modal}
          onClose={this.toogleConfirmModal}
          isOpen={visibleModalConfirm}
          footer={
            <div className={s.modalFooter}>
              <Button
                className={s.modalFooterBtn}
                onClick={this.onHandleSubmit}
                loading={loading}
                disabled={loading}
              >
                Đồng ý
              </Button>
            </div>
          }
        >
          <p className={s.titleModal}>Lưu ý</p>
          <div className={s.titleDes}>
            <p className={s.note}>
              Quý khách vui lòng chuẩn bị đầy đủ giấy tờ đã chọn, nếu không hồ
              sơ vay của quý khách sẽ bị từ chối
            </p>
          </div>
        </Modal>
        <Modal
          className={s.modal}
          onClose={this.toogleSelectDocModal}
          isOpen={visibleModalSelectDoc}
          footer={
            countSelectDocument ? (
              <div className={s.modalFooter}>
                <Button
                  className={s.modalFooterBtn}
                  onClick={this.toogleSelectDocModal}
                >
                  Chọn {countSelectDocument} giấy tờ
                </Button>
              </div>
            ) : (
              undefined
            )
          }
        >
          {this.renderDocumentOptions()}
        </Modal>
      </div>
    );
  }
}

AdditionalUserDocument.propTypes = {
  fullName: string,
};

AdditionalUserDocument.defaultProps = {
  fullName: null,
};

const mapStateToProps = ({ clz }) => ({
  user: clz.newBOD.user,
  token: clz.newBOD.token,
  userToken: clz.newBOD?.user?.token,
  fullName: clz.newBOD?.user?.fullName,
});
const mapDispatchToProps = dispatch => ({
  onAdditionDocument: (payload, token) => {
    dispatch(additionDocument(payload, token));
  },
  onGenerateUserToken: async (cuid, id, token) => {
    const userToken = await dispatch(generateUserToken(cuid, id, token));
    return userToken;
  },
});
const enhance = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withStyles(s),
);

export default enhance(AdditionalUserDocument);
